import { format } from 'date-fns';
import { info } from './Toast';

export function toastExistingCompletedCheck(createdAt?: string | null) {
  if (!createdAt) {
    return;
  }

  const date = format(new Date(createdAt), 'yyyy-MM-dd');
  info(`Bakgrundskontroll redan genomförd ${date}`);
}
